// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__lmLBW","button--loading":"Button_button--loading__j__a2","button__loader":"Button_button__loader__q8q2C"};